export class KeyHelper {
  public static getUniqueKey() {
    return "key-" + crypto.randomUUID().replaceAll("-", "_");
  }
}
